import React, { useEffect } from "react";
import web3Config from '../web3/web3Config.json';
import Cookies from "universal-cookie";
import Web3 from 'web3';
import { toast, Bounce } from 'react-toastify';
import { useSelector, useDispatch } from "react-redux";
import audio from '../assets/audio/notification.mp3';
import { useWalletReconnection } from "../helper/useWalletReconnection";
import { getEmails } from "../helper/emailHelper";
import { getHostContract } from "../helper/contract-helper";
import { getValidAccessToken } from "../auth/tokenGuard";
import { reportError, toErrorString } from "../utils/errorLogger";
const notificationSound = new Audio(audio);
const cookies = new Cookies();


const Notifications = () => {
    const dispatch = useDispatch();
    const refreshCount = useSelector((state) => state.refreshCount);
    useEffect(() => {
        // const interval = setInterval(() => {
        //     setValues();
        // }, 5000);
        // return () => clearInterval(interval);

        const hostContract = getHostContract(true);
        // No WSS_RPC_URL configured (or WS node unreachable) → rely on the SSE /events stream below.
        if (!hostContract) return;
        const eventListener = hostContract.events?.EmailCreated;
        if (eventListener) {
            const eventStream = eventListener({
                fromBlock: 'latest',
            });
            eventStream.on("data", async (event) => {
                const user = cookies.get("userObject");
                const userName = user.name;
                const usernameHash = Web3.utils.keccak256(userName);
                const senderHash = event.returnValues.senderName.hash;
                const recipientHash = event.returnValues.recipient.hash;
                if (usernameHash !== senderHash && usernameHash == recipientHash) {
                    setValues();
                }
            });
        }
    }, []);

    useWalletReconnection(() => {
        console.log("Wallet reconnected, refreshing notifications...");
        setValues();
    }, []);

    useEffect(() => {
        // NOT cookies.get(): the ML-DSA-87 token is ~10.5KB, over the browser's ~4KB
        // per-cookie limit, so the accessToken cookie is silently dropped and reads
        // return undefined. getValidAccessToken() falls back to localStorage.
        const token = getValidAccessToken();
        if (!token) return;
        const eventSource = new EventSource(
            `${web3Config.EMAIL_API}/events?token=${encodeURIComponent(token)}`
        );

        eventSource.onmessage = (event) => {
            const data = JSON.parse(event.data);
            const user = cookies.get("userObject");
            const userName = user.name;
            const receivedUser = `${data.split("@")[0]}@${web3Config.DOMAIN}`;
            if (receivedUser === userName) {
                const notifyMessage = `New web2 email received`;
                notificationSound.play();
                toast.info(notifyMessage, {
                    position: "top-center",
                    transition: Bounce,
                });
                dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
                window.dispatchEvent(new Event("REFRESH_COUNT"));
            }
        };

        eventSource.onerror = (error) => {
            console.error('EventSource failed:', error);
            eventSource.close();
        };

        return () => {
            eventSource.close();
        };
    }, []);

    const setValues = async () => {
        const user = cookies.get("userObject");
        if (window.ncogProvider && user) {
            const web3Instance = new Web3(web3Config?.CHAIN_DETAILS?.rpcUrls[0]);
            const userAccount = user.wallet || user.accountAddress;
            if (userAccount) {
                await getCount(web3Instance, userAccount);
            }
        }
    }
    let isReload = false;
    let initialCount = 0;
    const getCount = async (web3Value, account) => {
        if (!web3Value || !account) return;
        const user = cookies.get("userObject");
        const userName = user?.name ?? '';
        const emailList = await getEmails(userName);
        const emailDifference = Number(emailList.length) - initialCount;
        if (isReload && initialCount < Number(emailList.length)) {
            const notifyMessage = emailDifference > 1 ? `New ${emailDifference} emails received` : `New email received`;
            notificationSound.play();
            toast.dismiss()
            toast.info(notifyMessage, {
                position: "top-center",
                transition: Bounce,
            });
            dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
            window.dispatchEvent(new Event("REFRESH_COUNT"));
        }
        if (emailDifference) {
            initialCount = initialCount + emailDifference;
        }
        isReload = true;
    };

    return (
        <>
            {/* The Notifications component currently does not render any visible UI */}
        </>
    );
};

export default Notifications;